import Vue from "vue";
import { LinkMobilePluginOption } from "@/shared/plugins/link/types";

export function getRoutePath (url: string) {
  try {
    const validUrl = new URL(url);
    let path = url.replace(validUrl.origin, "");
    path = path.replace("#/", "");
    return path;
  } catch (_) {
    return "";
  }
}

export function openUrl (url: string): void {
  url = url.toLowerCase().startsWith("http") ? url : `//${url}`;
  Vue.prototype.$link.open(url, { mobilePlugin: LinkMobilePluginOption.InAppBrowser });
}

/**
 * This is used to open document urls
 * Browser: opens a document in a new tab
 * Mobile: opens a document using the file viewer plugins
 * @param url
 */
export function openDocumentUrl (url: string): void {
 Vue.prototype.$link.open(url, { mobilePlugin: LinkMobilePluginOption.FileViewer });
}

export function linkClickHandler (event: Event) {
  if (event.currentTarget instanceof HTMLAnchorElement) {
    openUrl(event.currentTarget.href);
  }
}
